export const formatBites = (size: number): string => {
  let i = Math.floor(Math.log(size) / Math.log(1024));
  i = i < 2 ? 2 : i;
  return `${parseFloat((size / Math.pow(1024, i)).toFixed(2))} ${['B', 'KB', 'MB', 'GB', 'TB'][i]}`;
};
